import { useEffect } from "react";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { PromoFeatureFlag, PromoFeatureName, PromoType } from "./types";
import { useAuthContext } from "providers/Auth";
import { shouldApplyPromo, cleanupPromoStorage } from "./utils";
import { useSessionStorage } from "shared/hooks/use-session-storage";
import moment from "moment";
import { FEATURE_FLAG_EXPIRY_DATE } from "./constants";

export const useShowPromo = () => {
  const showPromoBannerFF = useFeatureFlagEnabled(PromoFeatureFlag.Banner);
  const showPromoModalFF = useFeatureFlagEnabled(PromoFeatureFlag.Modal);
  const promoModalSessionData = useSessionStorage("hidePromoModal");
  const promoBannerSessionData = useSessionStorage("hidePromoBanner");

  const { type, auth } = useAuthContext();

  useEffect(() => {
    if (moment().isAfter(FEATURE_FLAG_EXPIRY_DATE))
      cleanupPromoStorage(PromoFeatureName.CombinedIncome);
  }, []);

  const showPromoModal = shouldApplyPromo(
    PromoFeatureName.CombinedIncome,
    PromoType.Modal,
    {
      isBoomScreen: type.isBoomScreen,
      partnerCreatedAt: auth?.created_at,
      featureFlagEnabled: showPromoModalFF,
      sessionPromoData: promoModalSessionData
    }
  );

  const showPromoBanner =
    !showPromoModal &&
    shouldApplyPromo(PromoFeatureName.CombinedIncome, PromoType.Banner, {
      isBoomScreen: type.isBoomScreen,
      partnerCreatedAt: auth?.created_at,
      featureFlagEnabled: showPromoBannerFF,
      sessionPromoData: promoBannerSessionData
    });

  return {
    showPromoModal,
    showPromoBanner
  };
};
